import React from 'react';

const States = ({ onMouseMove, onMouseLeave }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="tiny"
      height="480"
      strokeLinecap="round"
      strokeLinejoin="round"
      version="1.2"
      viewBox="0 0 800 540"
      width="700"
      id="State"
    >
      <g id="US States" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
        <path
          className="white"
          d="M 651.02 213.84 687.32 206.5 704.9 202.49 711.82 226.1 721.5 224.03 720.49 232.76 714.38 235.69 709.85 230.91 695.13 233.58 689.68 227.48 690.41 224.23 688.63 221.78 678.24 216.31 671.56 210.79 657.54 217.47 652.68 223.6 651.02 213.84 Z"
          data-stusps="MD"
          id="24"
        />
        <path
          className="white"
          d="M 404.95 164.92 453.93 164.25 476.52 163.2 478.97 167.7 478.24 174.34 485.53 181.35 492.73 188.47 490.85 198.16 481.33 202.03 482.89 210.78 476.79 221.93 472.13 217.73 432.02 219.77 414.4 219.64 412.17 203.31 406.24 189.95 404.92 183.87 402.52 178.44 405.09 172.18 404.95 164.92 Z"
          data-stusps="IA"
          id="19"
        />
        <path
          className="white"
          d="M 710 199.7 709.71 205.84 715.63 216.16 719.34 217.6 721.5 224.03 711.82 226.1 704.9 202.49 710 199.7 Z"
          data-stusps="DE"
          id="10"
        />
        <path
          className="white"
          d="M 568.67 188.8 587.64 185.48 596.8 186.9 602.67 189.87 612.59 186.29 618.11 180.09 628.18 174.08 632.75 199.29 631.31 217.55 627.79 223.24 620.27 227.87 618.06 234.87 613.84 237.97 613.15 244.89 609.22 246 603.93 240.33 598.48 244.12 584.27 242.06 579.85 236.58 574.63 237.54 568.67 188.8 Z"
          data-stusps="OH"
          id="39"
        />
        <path
          className="white"
          d="M 628.18 174.08 637.76 166.58 638.76 171.68 669 165.43 700.94 158.05 706.14 161.56 708.37 166.13 713.12 167.72 708.66 176.42 709.8 184.37 718.48 190.57 710 199.7 704.9 202.49 687.32 206.5 651.02 213.84 635.81 216.59 632.75 199.29 628.18 174.08 Z"
          data-stusps="PA"
          id="42"
        />
        <path
          className="white"
          d="M 300.12 168.78 327.29 171.16 376.69 173.79 385.46 176.54 394.02 176.94 404.92 183.87 406.24 189.95 412.17 203.31 414.4 219.64 421.01 230.59 396.46 230.48 355.98 229.31 323.66 227.43 324.98 208.67 296.49 206.32 300.12 168.78 Z"
          data-stusps="NE"
          id="31"
        />
        <path
          className="white"
          d="M 152.21 24.52 138.6 71.52 137.72 80.87 110.78 72.91 108.58 73.6 81.3 70.65 72.18 66.3 65.22 67.25 59.44 62.32 60.83 56.92 58.46 51.31 53.41 47.85 46.62 45.07 49.99 36.42 52.83 17.13 51.65 10.8 55.09 3.08 60.89 9.98 73.17 16.62 76.54 16.79 81.1 9.14 82.6 1 116.01 13.11 152.21 24.52 Z"
          data-stusps="WA"
          id="53"
        />
        <path
          className="white"
          d="M 531.33 319.89 571.56 316.47 582.29 355.82 588.13 366.62 584.92 375.03 588.75 390.64 546.57 394.35 550.28 400.51 548.89 407.74 534.45 407.07 531.28 377.75 533.06 321.71 531.33 319.89 Z"
          data-stusps="AL"
          id="1"
        />
        <path
          className="white"
          d="M 431.84 296.12 454.43 295.69 499.48 293.77 501.06 297.29 496.75 303.33 506.45 302.66 498.71 322.05 494.79 329.41 495.17 333.16 490.38 336.99 485.96 350.26 488.53 355.72 487.18 360.08 441.71 361.19 441.53 351.22 434.56 349.71 434.96 317.25 431.84 296.12 Z"
          data-stusps="AR"
          id="5"
        />
        <path
          className="white"
          d="M 214.19 272.93 253.06 277.97 279.4 280.7 305.51 282.79 304.8 292.17 304.2 292.13 297.82 376.65 240.75 371.86 241.79 376.1 214.66 373.18 213.68 381.7 199.98 380.1 204.98 340.77 214.19 272.93 Z"
          data-stusps="NM"
          id="35"
        />
        <path
          className="white"
          d="M 304.8 292.17 350.32 294.87 348.78 331.24 353.37 334.79 359.93 334.92 361.15 338.19 378.09 340.72 381.64 345.58 388.23 346.17 395.95 344.01 405.13 348.77 408.46 346.21 422.92 343.75 434.56 349.71 441.53 351.22 441.71 361.19 442.05 380.43 450.47 395.39 450.64 400.28 447.57 407.45 448.15 416.63 446.08 423.48 433.74 427.82 420.88 439.18 407.47 446 395.94 454.76 389 465.99 387.53 472.84 391.23 493.26 386.51 495.66 380.26 491.55 373.46 491.42 358.17 484.16 353.17 470.28 351.3 461.69 346.59 458.46 339.86 449.38 333.74 433.19 322.34 420.68 307.72 417.29 301.41 419.55 297.66 428.69 290.58 433.15 276.84 424.65 270.73 418.65 268.83 408.36 264.65 399.29 259.77 396.14 246.89 382.83 241.79 376.1 240.75 371.86 297.82 376.65 304.2 292.13 304.8 292.17 Z"
          data-stusps="TX"
          id="48"
        />
        <path
          className="white"
          d="M 14.91 124.19 59.61 139.39 74.2 143.86 57.63 200.6 80.29 235.1 121.64 296.28 121.14 298.74 126.74 311.92 119.26 317.06 118.07 324.28 114.51 327.09 111.97 339.64 72.16 335.48 69.97 320.23 60.96 308.43 56.63 307.79 55.96 301.72 46.8 298.18 40.22 289.89 26.99 286 24.56 282.6 27.49 272.17 24 268.67 16.59 247.56 14.4 238.23 18.47 234.57 11.26 224.65 11.38 217.68 17.64 216.51 7.98 205.89 8.62 200.51 1.85 185.28 5.66 167.05 1 156.31 1.51 152.71 9.42 143.74 13.23 135.5 14.91 124.19 Z"
          data-stusps="CA"
          id="6"
        />
        <path
          className="white"
          d="M 514.32 283.63 517.01 278.8 524.1 281.27 523.76 275.02 529.68 272.89 529.7 267 538.55 263.47 542.28 265.08 549.02 263.46 554.5 258.07 560.67 259.68 561.73 254.72 575.64 241.68 574.63 237.54 579.85 236.58 584.27 242.06 598.48 244.12 603.93 240.33 609.22 246 609.53 251.48 615.71 259.22 621.05 261.29 610.78 271 605.53 278.81 597.68 282.57 564.21 286.04 534.17 288.69 531.38 291.44 508.79 293.14 514.25 289.66 514.32 283.63 Z"
          data-stusps="KY"
          id="21"
        />
        <path
          className="white"
          d="M 571.56 316.47 591.47 314.21 610.31 311.65 607.49 318.13 615.27 321.18 621.56 330.47 632.78 338.27 636.31 343.8 640.71 345.82 643.47 353.36 647.1 355.57 649.35 362.07 653.25 363.05 650.1 369.53 647.57 389.47 639.09 388.29 635.2 393.84 591.54 395.87 588.75 390.64 584.92 375.03 588.13 366.62 582.29 355.82 571.56 316.47 Z"
          data-stusps="GA"
          id="13"
        />
        <path
          className="white"
          d="M 462.76 103.58 473.56 100.39 483.58 105 487.75 109.03 514.59 114.59 519.45 118.81 518.97 124.94 523.08 129.41 527.44 129.22 523.43 152.54 522.37 163.37 525.07 178.57 485.53 181.35 478.24 174.34 478.97 167.7 476.52 163.2 472.97 153.96 465.56 147.55 453.93 140.4 455.56 127.76 452.42 122.67 459.69 115.62 459.22 104.56 462.76 103.58 Z"
          data-stusps="WI"
          id="55"
        />
        <path
          className="white"
          d="M 53.41 47.85 58.46 51.31 60.83 56.92 59.44 62.32 65.22 67.25 72.18 66.3 81.3 70.65 108.58 73.6 110.78 72.91 137.72 80.87 141.7 89.58 133.33 101.11 125.1 109.7 128.58 115.41 125.18 121.15 116.08 155.45 74.2 143.86 59.61 139.39 14.91 124.19 13.84 118.42 16.63 110.74 15.98 106.59 25.37 94.78 39.99 66.43 47.28 48.01 53.41 47.85 Z"
          data-stusps="OR"
          id="41"
        />
        <path
          className="white"
          d="M 414.4 219.64 432.02 219.77 472.13 217.73 476.79 221.93 475.65 225.9 478.14 234.08 487.9 242.46 489.32 248.7 497.38 249.55 494.16 259.65 496.7 263.82 507.55 270.62 510.83 282.73 514.32 283.63 514.25 289.66 508.79 293.14 506.45 302.66 496.75 303.33 501.06 297.29 499.48 293.77 454.43 295.69 431.84 296.12 431.72 286.76 431.35 247.11 423.88 238.93 427.52 235.23 421.01 230.59 414.4 219.64 Z"
          data-stusps="MO"
          id="29"
        />
        <path
          className="white"
          d="M 714.38 235.69 720.49 232.76 717.03 239.14 715.36 250.59 711.83 249.46 714.38 235.69 Z M 621.05 261.29 623.55 265.79 628.15 266.61 637.55 263.2 646.3 257.28 645.82 254.5 651.44 242.03 652.42 235.65 658.25 238 661.18 229.16 668.65 221.47 668.47 215.46 677.38 220.22 678.24 216.31 688.63 221.78 690.41 224.23 689.68 227.48 687.49 231.27 693.88 234.93 699.36 235.06 706.1 238.76 707.83 247.68 706.45 251.89 709.44 256.43 713.76 256.35 717.28 262.99 676.74 271.33 649.4 276.07 628.16 278.57 597.68 282.57 605.53 278.81 610.78 271 621.05 261.29 Z"
          data-stusps="VA"
          fillRule="evenodd"
          id="51"
        />
        <path
          className="white"
          d="M 506.45 302.66 508.79 293.14 531.38 291.44 534.17 288.69 564.21 286.04 597.68 282.57 628.16 278.57 624.08 288.13 612.9 292.24 610.38 296.62 602.9 301.81 598.69 302.36 591.55 309.64 591.47 314.21 571.56 316.47 531.33 319.89 498.71 322.05 506.45 302.66 Z"
          data-stusps="TN"
          id="47"
        />
        <path
          className="white"
          d="M 441.71 361.19 487.18 360.08 490.03 376.92 485.07 382.8 481.2 397.98 512.07 396.49 510.6 401.75 516.24 411.73 521.89 413.61 517.73 426.24 522.44 427.14 523.62 433 511.89 428.19 505.83 432.89 495.22 433.92 488.31 430.59 486.23 425.99 475.18 424.72 470.96 425.87 456.87 421.77 446.08 423.48 448.15 416.63 447.57 407.45 450.64 400.28 450.47 395.39 442.05 380.43 441.71 361.19 Z"
          data-stusps="LA"
          id="22"
        />
        <path
          className="white"
          d="M 637.76 166.58 645.36 159.31 648.47 154.22 643.61 145.99 650.37 142.47 661.29 140.64 664.61 141.98 672.7 139.42 678.9 132.97 680.17 127.02 677.54 119.71 681.4 115.85 688.23 103.91 693.05 99.47 712.89 93.95 716.67 104.43 716.89 112.45 722.28 121.22 726.18 136.14 726.74 150.13 729.73 164.61 729.78 170.88 737.7 169 749.04 163.86 740.62 174.15 723.5 182.28 726.33 171.55 713.12 167.72 708.37 166.13 706.14 161.56 700.94 158.05 669 165.43 638.76 171.68 637.76 166.58 Z"
          data-stusps="NY"
          id="36"
        />
        <path
          className="white"
          d="M 587.64 185.48 568.67 188.8 568.52 187.59 540.1 190.93 545.66 180.94 546.62 171.16 545.29 165.21 540.16 155.12 539.63 147.32 542.33 141.54 543.87 130.59 552.59 126.91 554.75 116.64 559.48 112 578.49 118.82 580.8 123.21 581.89 136.39 575.3 148.85 579.31 151.04 582.14 144.29 588.18 140.47 592.91 144.29 598.42 159.32 598.24 166.45 593.67 169.01 587.64 185.48 Z M 483.58 105 490.83 99.99 496.15 98.81 510.46 86.08 512.3 95.03 519.71 97.75 523.22 102.61 533.75 101.8 538.76 97.66 553.09 95.73 554.38 99.35 565.3 96.98 567.33 107.16 560.15 108.59 547.94 107.8 543.45 111.43 538.63 111.59 527.49 118.2 523.08 129.41 518.97 124.94 519.45 118.81 514.59 114.59 487.75 109.03 483.58 105 Z"
          data-stusps="MI"
          fillRule="evenodd"
          id="26"
        />
        <path
          className="white"
          d="M 137.72 80.87 138.6 71.52 152.21 24.52 164.24 27.92 159.1 46.53 161.65 53.28 160.43 58.53 164.5 62.83 167.54 71.32 174.52 77.43 169.65 88.46 167.17 97.2 174.83 96.22 182.46 122.14 202.18 124.59 208.79 127.45 200.16 173.92 158.04 165.62 116.08 155.45 125.18 121.15 128.58 115.41 125.1 109.7 133.33 101.11 141.7 89.58 137.72 80.87 Z"
          data-stusps="ID"
          id="16"
        />
        <path
          className="white"
          d="M 588.75 390.64 591.54 395.87 635.2 393.84 639.09 388.29 647.57 389.47 652.96 406.66 659.38 418.15 667.16 427.81 669.13 438.2 680.6 459.84 682 479.91 679.16 484.24 679.22 493.17 666.72 495.27 660.03 483.29 653.83 481.46 649.33 471.75 644.84 471.47 642.82 466.29 634.15 454.14 629.8 440.45 632.42 434.2 631.12 426.25 622.29 419.84 612.55 408.86 605.86 406.07 590.63 417.4 585.42 416.5 584.44 411.62 573.75 405.92 563.19 404.43 548.89 407.74 550.28 400.51 546.57 394.35 588.75 390.64 Z"
          data-stusps="FL"
          id="12"
        />
        <path
          className="white"
          d="M 476.79 221.93 482.89 210.78 481.33 202.03 490.85 198.16 492.73 188.47 485.53 181.35 525.07 178.57 524.93 182.19 530.35 192.91 534.46 237.26 533.51 242 535.96 248.3 529.29 262.65 529.7 267 529.68 272.89 523.76 275.02 524.1 281.27 517.01 278.8 514.32 283.63 510.83 282.73 507.55 270.62 496.7 263.82 494.16 259.65 497.38 249.55 489.32 248.7 487.9 242.46 478.14 234.08 475.65 225.9 476.79 221.93 Z"
          data-stusps="IL"
          id="17"
        />
        <path
          className="white"
          d="M 164.24 27.92 193.09 35.49 220.01 41.61 250.78 47.54 287.15 53.21 311.87 56.22 305.81 113.52 303.82 131.29 274.42 127.95 244.63 123.54 210.75 117.57 208.79 127.45 202.18 124.59 182.46 122.14 174.83 96.22 167.17 97.2 169.65 88.46 174.52 77.43 167.54 71.32 164.5 62.83 160.43 58.53 161.65 53.28 159.1 46.53 164.24 27.92 Z"
          data-stusps="MT"
          id="30"
        />
        <path
          className="white"
          d="M 396.15 61.55 421.82 61.7 427.56 65.57 442.94 69.79 449.27 67.96 467.47 77.98 476.04 73.88 477.98 76.53 485.1 75.73 487.54 80.86 476.56 86.79 462.76 103.58 459.22 104.56 459.69 115.62 452.42 122.67 455.56 127.76 453.93 140.4 465.56 147.55 472.97 153.96 476.52 163.2 453.93 164.25 404.95 164.92 405.14 131.01 400.34 124.46 403.85 119.22 401.03 106.01 400.44 88.45 396.9 77.19 397.65 67.82 396.15 61.55 Z"
          data-stusps="MN"
          id="27"
        />
        <path
          className="white"
          d="M 530.35 192.91 534.22 194.2 540.1 190.93 568.52 187.59 568.67 188.8 574.63 237.54 575.64 241.68 561.73 254.72 560.67 259.68 554.5 258.07 549.02 263.46 542.28 265.08 538.55 263.47 529.7 267 529.29 262.65 535.96 248.3 533.51 242 534.46 237.26 530.35 192.91 Z"
          data-stusps="IN"
          id="18"
        />
        <path
          className="white"
          d="M 726.18 136.14 737.49 133.28 753.83 128.97 759.41 123.6 763.4 128.34 760.28 134.01 773.79 144.8 768.79 149.36 763.23 150.84 756.54 142.12 750.72 144.1 726.74 150.13 726.18 136.14 Z"
          data-stusps="MA"
          id="25"
        />
        <path
          className="white"
          d="M 323.66 227.43 355.98 229.31 396.46 230.48 421.01 230.59 427.52 235.23 423.88 238.93 431.35 247.11 431.72 286.76 388.92 286.67 359.66 285.86 319.97 283.94 323.66 227.43 Z"
          data-stusps="KS"
          id="20"
        />
        <path
          className="white"
          d="M 74.2 143.86 116.08 155.45 158.04 165.62 144.17 230.21 138.14 260.03 135.19 275.36 124.21 274.96 121.64 296.28 80.29 235.1 57.63 200.6 74.2 143.86 Z"
          data-stusps="NV"
          id="32"
        />
        <path
          className="white"
          d="M 712.89 93.95 737.32 86.41 739.32 96.32 734.28 102.2 735.49 105.7 733.85 117.03 737.49 133.28 726.18 136.14 722.28 121.22 716.89 112.45 716.67 104.43 712.89 93.95 Z"
          data-stusps="VT"
          id="50"
        />
        <path
          className="white"
          d="M 726.74 150.13 750.72 144.1 753.7 157.34 738.7 162.9 729.78 170.88 729.73 164.61 726.74 150.13 Z"
          data-stusps="CT"
          id="9"
        />
        <path
          className="white"
          d="M 710 199.7 718.48 190.57 709.8 184.37 708.66 176.42 713.12 167.72 726.33 171.55 723.5 182.28 728.44 184.13 729.43 195.83 726.75 204.47 720.78 210.31 709.71 205.84 710 199.7 Z"
          data-stusps="NJ"
          id="34"
        />
        <g />
        <path
          className="white"
          d="M 628.16 278.57 649.4 276.07 676.74 271.33 717.28 262.99 727.55 279.82 727.9 287.16 719.37 293.69 714.62 302.58 711.2 301.12 704.97 303.59 698.08 310.29 694.69 320.89 685.45 322.56 664.46 307.46 646.84 309.9 642.06 304.32 620.64 306.39 610.31 311.65 591.47 314.21 591.55 309.64 598.69 302.36 602.9 301.81 610.38 296.62 612.9 292.24 624.08 288.13 628.16 278.57 Z"
          data-stusps="NC"
          id="37"
        />
        <path
          className="white"
          d="M 158.04 165.62 200.16 173.92 196.76 192.82 225.27 197.5 217.43 248.82 214.19 272.93 180.32 267.7 138.14 260.03 144.17 230.21 158.04 165.62 Z"
          data-stusps="UT"
          id="49"
        />
        <path
          className="white"
          d="M 311.87 56.22 334.49 58.43 362.96 60.38 396.15 61.55 397.65 67.82 396.9 77.19 400.44 88.45 401.03 106.01 403.85 119.22 365.49 118.07 325.39 115.37 305.81 113.52 311.87 56.22 Z"
          data-stusps="ND"
          id="38"
        />
        <path
          className="white"
          d="M 610.31 311.65 620.64 306.39 642.06 304.32 646.84 309.9 664.46 307.46 685.45 322.56 682.03 324.77 677.42 332.68 676.91 337.62 665.95 350.08 660.87 353.32 653.25 363.05 649.35 362.07 647.1 355.57 643.47 353.36 640.71 345.82 636.31 343.8 632.78 338.27 621.56 330.47 615.27 321.18 607.49 318.13 610.31 311.65 Z"
          data-stusps="SC"
          id="45"
        />
        <path
          className="white"
          d="M 487.18 360.08 488.53 355.72 485.96 350.26 490.38 336.99 495.17 333.16 494.79 329.41 498.71 322.05 531.33 319.89 533.06 321.71 531.28 377.75 534.45 407.07 526.29 407.14 516.24 411.73 510.6 401.75 512.07 396.49 481.2 397.98 485.07 382.8 490.03 376.92 487.18 360.08 Z"
          data-stusps="MS"
          id="28"
        />
        <path
          className="white"
          d="M 225.27 197.5 266.04 203.13 296.49 206.32 324.98 208.67 323.66 227.43 319.97 283.94 305.51 282.79 279.4 280.7 253.06 277.97 214.19 272.93 217.43 248.82 225.27 197.5 Z"
          data-stusps="CO"
          id="8"
        />
        <path
          className="white"
          d="M 303.82 131.29 305.81 113.52 325.39 115.37 365.49 118.07 403.85 119.22 400.34 124.46 405.14 131.01 404.95 164.92 405.09 172.18 402.52 178.44 404.92 183.87 394.02 176.94 385.46 176.54 376.69 173.79 327.29 171.16 300.12 168.78 303.82 131.29 Z"
          data-stusps="SD"
          id="46"
        />
        <path
          className="white"
          d="M 305.51 282.79 319.97 283.94 359.66 285.86 388.92 286.67 431.72 286.76 431.84 296.12 434.96 317.25 434.56 349.71 422.92 343.75 408.46 346.21 405.13 348.77 395.95 344.01 388.23 346.17 381.64 345.58 378.09 340.72 361.15 338.19 359.93 334.92 353.37 334.79 348.78 331.24 350.32 294.87 304.8 292.17 305.51 282.79 Z"
          data-stusps="OK"
          id="40"
        />
        <path
          className="white"
          d="M 303.82 131.29 300.12 168.78 296.49 206.32 266.04 203.13 225.27 197.5 196.76 192.82 200.16 173.92 208.79 127.45 210.75 117.57 244.63 123.54 274.42 127.95 303.82 131.29 Z"
          data-stusps="WY"
          id="56"
        />
        <path
          className="white"
          d="M 609.22 246 613.15 244.89 613.84 237.97 618.06 234.87 620.27 227.87 627.79 223.24 631.31 217.55 632.75 199.29 635.81 216.59 651.02 213.84 652.68 223.6 657.54 217.47 671.56 210.79 678.24 216.31 677.38 220.22 668.47 215.46 668.65 221.47 661.18 229.16 658.25 238 652.42 235.65 651.44 242.03 645.82 254.5 646.3 257.28 637.55 263.2 628.15 266.61 623.55 265.79 621.05 261.29 615.71 259.22 609.53 251.48 609.22 246 Z"
          data-stusps="WV"
          id="54"
        />
        <path
          className="white"
          d="M 741.07 79.17 744.28 75.51 748.21 64.64 745.9 59.29 746.37 48.51 751.12 30.85 757.04 34.51 764.68 28.21 771.87 31.25 781.61 57.02 787.9 58.36 788.75 63.02 794.72 64.05 799 68.7 796 74.53 786.36 82.65 784 89.25 773.78 98.32 763.42 105.63 759.85 119.57 754.09 114.86 741.07 79.17 Z"
          data-stusps="ME"
          id="23"
        />
        <path
          className="white"
          d="M 737.32 86.41 741.07 79.17 754.09 114.86 759.85 119.57 759.41 123.6 753.83 128.97 737.49 133.28 733.85 117.03 735.49 105.7 734.28 102.2 739.32 96.32 737.32 86.41 Z"
          data-stusps="NH"
          id="33"
        />
        <path
          className="white"
          d="M 111.97 339.64 114.51 327.09 118.07 324.28 119.26 317.06 126.74 311.92 121.14 298.74 121.64 296.28 124.21 274.96 135.19 275.36 138.14 260.03 180.32 267.7 214.19 272.93 204.98 340.77 199.98 380.1 166.96 375.76 132.19 356.57 109.65 343.66 111.97 339.64 Z"
          data-stusps="AZ"
          id="4"
        />
        <path
          className="white"
          d="M 753.7 157.34 750.72 144.1 756.54 142.12 763.23 150.84 753.7 157.34 Z"
          data-stusps="RI"
          id="44"
        />
        <path
          className="white"
          d="M 689.7 226.46 689.67 226.29 689.63 226.01 689.55 225.87 689.57 225.74 689.44 225.65 689.42 225.56 689.57 225.53 689.57 225.33 689.54 225.24 689.44 225.14 689.41 225.02 689.31 224.91 689.23 224.98 689.12 224.84 689.04 224.83 688.94 224.7 688.84 224.51 688.79 224.48 688.55 224.5 688.44 224.47 688.27 224.37 688.18 224.24 688.08 224.17 687.93 224.01 688.85 222.6 689.17 222.81 691.21 224.13 689.7 226.46 Z"
          data-stusps="DC"
          id="11"
        />
      </g>
    </svg>
  );
};

export default States;
